import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Orders from './pages/Orders';
import DashboardLayout from './pages/DashboardLayout';
import Feedback from './pages/Feedback';
import EmailManagement from './pages/EmailManagement';
import Careers from './pages/Careers';
import Events from './pages/Events';
import CampusConnect from './pages/CampusConnect';
import CampusAlpha from './pages/CampusAlpha';
import Hackathons from './pages/Hackathons';
import HackathonResults from './pages/HackathonResults';
import CourseContent from './pages/CourseContent';
import Timeline from './pages/Timeline';
import Practice from './pages/Practice';
import TakumiCertifications from './pages/TakumiCertifications';
import TakumiGroupDoubts from './pages/TakumiGroupDoubts';
import Affiliates from './pages/Affiliates';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/auth" element={<AuthPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              {/* /dashboard/feedback */}
              <Route path="feedback" element={<Feedback />} />
              <Route path="email" element={<EmailManagement />} />
              <Route path="careers" element={<Careers />} />
              <Route path="events" element={<Events />} />
              <Route path="campus-connect" element={<CampusConnect />} />
              <Route path="orders" element={<Orders />} />
              <Route path="campus-alpha" element={<CampusAlpha />} />
              <Route path="hackathons" element={<Hackathons />} />
              <Route path="hackathon-results" element={<HackathonResults />} />
              <Route path="course-content" element={<CourseContent />} />
              <Route path="timeline" element={<Timeline />} />
              <Route path="practice" element={<Practice />} />
              <Route path="takumi-certifications" element={<TakumiCertifications />} />
              <Route path="takumi-doubts" element={<TakumiGroupDoubts />} />
              <Route path="affiliates" element={<Affiliates />} />
            </Route>
            <Route path="/" element={<Navigate to="/auth" replace />} />

          </Routes>
        </div>
      </Router>
    </AuthProvider>

  );
}

export default App;